<template>
    <div>
        <h1>{{message}}</h1>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        data: function () {
            return {
                message: 'ABOUT'
            }
        },

        computed: {

        },

        methods: {

        },

        props: {

        }

    });
</script>